import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "panel", "toggle", "openIcon", "closeIcon" ]

  connect() {
    this.open = false
  }

  toggle() {
    this.open ? this.close() : this.openMenu()
  }

  openMenu() {
    this.open = true
    this.panelTarget.classList.remove("hidden")
    this.panelTarget.setAttribute("aria-hidden", "false")
    this.toggleTarget.setAttribute("aria-expanded", "true")
    this.toggleTarget.setAttribute("aria-label", "Close menu")
    this.openIconTarget.classList.add("hidden")
    this.closeIconTarget.classList.remove("hidden")
  }

  close() {
    this.open = false
    this.panelTarget.classList.add("hidden")
    this.panelTarget.setAttribute("aria-hidden", "true")
    this.toggleTarget.setAttribute("aria-expanded", "false")
    this.toggleTarget.setAttribute("aria-label", "Open menu")
    this.openIconTarget.classList.remove("hidden")
    this.closeIconTarget.classList.add("hidden")
  }

  keydown(event) {
    if (event.key === "Escape") {
      this.close()
      this.toggleTarget.focus()
    }
  }
}
